<template>
  <div class="tag">
    <div class="container">
      <div class="tag__wrapper">
        <div class="tag__left" :class="[{ new: tag?.tagName === 'new' }]">
          <div class="tag__top">
            <h2 class="tag__top-title">{{ tag.name }}</h2>
            <div class="tag__top-buttons">
              <svg ref="prevButton" width="49" viewBox="0 0 49 48" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_96_559)">
                  <path d="M24.6602 47.5C37.6388 47.5 48.1602 36.9787 48.1602 24C48.1602 11.0213 37.6388 0.5 24.6602 0.5C11.6815 0.5 1.16016 11.0213 1.16016 24C1.16016 36.9787 11.6815 47.5 24.6602 47.5Z" stroke="#DCE5EB"/>
                  <path d="M26.9672 29.5602L21.3252 23.9182L26.9672 18.2769" stroke="#546179" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                </g>
              </svg>
              <svg ref="nextButton" width="49" viewBox="0 0 49 48" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_96_559)">
                  <path d="M24.6602 47.5C37.6388 47.5 48.1602 36.9787 48.1602 24C48.1602 11.0213 37.6388 0.5 24.6602 0.5C11.6815 0.5 1.16016 11.0213 1.16016 24C1.16016 36.9787 11.6815 47.5 24.6602 47.5Z" stroke="#DCE5EB"/>
                  <path d="M26.9672 29.5602L21.3252 23.9182L26.9672 18.2769" stroke="#546179" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                </g>
              </svg>
            </div>
          </div>
          <swiper
              class="swiper"
              :modules="[Navigation]"
              :navigation="{ prevEl: prevButton, nextEl: nextButton }"
              :spaceBetween="30"
              :speed="300"
              :breakpoints="{
                200: {
                  slidesPerView: 1
                },
                500: {
                  slidesPerView: tag?.tagName === 'new' ? 1 : 2
                },
                750: {
                  slidesPerView: tag?.tagName === 'new' ? 1 : 3
                },
                1000: {
                  slidesPerView: tag?.tagName === 'new' ? 1 : 4
                },
                1300: {
                  slidesPerView: tag?.tagName === 'new' ? 1 : 5
                }
              }"
          >
            <swiper-slide
                class="swiper__slide"
                v-for="(productGroup, groupIndex) in products"
                :key="groupIndex"
            >
              <div v-if="tag?.tagName === 'new'" class="swiper__slide-grid">
                <product-card
                    v-for="product in productGroup"
                    :key="product.node.uuid"
                    :product="product.node"
                />
              </div>
              <product-card v-else :product="productGroup.node" />
            </swiper-slide>
          </swiper>
        </div>
        <img class="tag__banner" v-if="tag?.tagName === 'new'" src="@images/homeBanner2.png" alt="banner" loading="lazy">
      </div>
    </div>
  </div>
</template>

<script setup>
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/css/navigation';
import 'swiper/css';
import {Navigation} from "swiper/modules";
import {onMounted, ref} from "vue";
import ProductCard from "@/components/cards/product-card.vue";
import {useI18n} from "vue-i18n";

const {t} = useI18n()

const props = defineProps({
  tag: Object,
})

const prevButton = ref(null)
const nextButton = ref(null)
const products = ref([])

onMounted(() => {
  if (props.tag?.tagName === 'new') {
    const productNodes = props.tag.productSet.edges;
    const groupedProducts = [];

    for (let i = 0; i < productNodes.length; i += 6) {
      const group = productNodes.slice(i, i + 6);
      groupedProducts.push(group);
    }

    products.value = groupedProducts;
  } else {
    products.value = props.tag?.productSet?.edges || [];
  }
})
</script>

<style lang="scss" scoped>
.tag {
  margin-top: 75px;

  &__wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 50px;
  }

  &__top {
    display: flex;
    align-items: center;
    justify-content: space-between;

    &-buttons {
      display: flex;
      align-items: center;
      gap: 15px;

      & svg {
        cursor: pointer;
        transition: 0.2s;
        color: $white;

        &:last-child {
          transform: rotate(180deg);
        }

        @include hover {
          color: #e5e5e5;
        }
      }
    }

    &-title {
      color: #2F2F2F;
      font-size: 47px;
      font-weight: 700;
      line-height: 52px;
    }
  }

  &__left {
    width: 100%;

    &.new {
      width: 60%;
    }
  }
}

.swiper {
  width: 100%;
  padding-block: 30px;

  &__slide {
    display: grid;
    place-items: center;

    &-grid {
      display: grid;
      grid-template-columns: repeat(3, 220px);
      justify-content: space-between;
      gap: 20px;
      width: 100%;
    }
  }
}

@media (max-width: 1300px) {
  .swiper {
    &__slide {
      &-grid {
        grid-template-columns: repeat(2, 220px);
        justify-content: space-around;
      }
    }
  }

  .new {
    width: 50% !important;
  }
}

@media (max-width: 1000px) {
  .swiper {
    &__slide {
      &-grid {
        grid-template-columns: repeat(3, 220px);
        justify-content: space-between;
      }
    }
  }

  .tag {
    &__banner {
      display: none;
    }
  }

  .new {
    width: 100% !important;
  }
}

@media (max-width: 750px) {
  .swiper {
    &__slide {
      &-grid {
        grid-template-columns: repeat(2, 220px);
        justify-content: space-around;
      }
    }
  }
}

@media (max-width: 500px) {
  .swiper {
    &__slide {
      &-grid {
        grid-template-columns: repeat(1, 220px);
        justify-content: space-around;
      }
    }
  }
}
</style>